export default __webpack_public_path__ + "static/media/Virtual-Glass-Wordmark-OneLine_Clear.c8bf4f85.png";